/**
 * Supplier Fee API
 * 협력사 수수료 관리 API
 */
import { apiClient } from "@/shared/api/client";
import {
    GetSupplierFeeListResponseDto,
    GetRiderListResponseDto,
    RegisterSupplierFeeRequestDto,
    UpdateSupplierFeeRequestDto
} from "../types/supplierFee.types";
import { ApiResponseDto } from "@/shared/types/apiTypes";

const RIDER_BASE_PATH = '/api/v1/rider';

/**
 * Supplier Fee API 서비스
 */
export const supplierFeeApi = {
    /**
     * 협력사 소속 라이더 목록 조회 (계약중인 라이더만)
     * GET /api/v1/rider/list?suppId={suppId}&statusCode=CONTRACT
     */
    getRiderList: async (suppId: string): Promise<GetRiderListResponseDto> => {
        const response = await apiClient.get<GetRiderListResponseDto>(
            `${RIDER_BASE_PATH}/list`,
            { params: { suppId, statusCode: 'UNDER_CONTRACT' } }
        );
        return response.data;
    },

    /** 계약 상태 무관 전체 라이더 목록 조회 (지급 결과 이름 표시용) */
    getAllRiderList: async (suppId: string): Promise<GetRiderListResponseDto> => {
        const response = await apiClient.get<GetRiderListResponseDto>(
            `${RIDER_BASE_PATH}/list`,
            { params: { suppId } }
        );
        return response.data;
    },
};
